import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
var __jsx = React.createElement;
import * as React from 'react';
import styled from 'styled-components';
import { NextSeo } from 'next-seo';
import * as url from '@bob/url';
import { Container, BreadCrumbs, breakpoint, styles as S } from '@bob/design-system';
import { SITE_NAME, SITE_URL } from '../../../../constants';
import { TagList } from '../../../../components/TagList';
import { Head } from './Head';
import { Content } from './Content';
import { Author } from './Author';
import { Similar } from './Similar';
export function Article(_ref) {
  var _article$seo$alt, _article$seo$height, _article$seo$width, _article$firstPublish;

  var article = _ref.article;
  var pageUrl = url.article({
    slug: article.slug,
    title: article.title
  });

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      readTime = _React$useState2[0],
      setReadTime = _React$useState2[1];

  return __jsx(React.Fragment, null, __jsx(NextSeo, {
    title: "".concat(article.title, " | ").concat(SITE_NAME),
    description: article.hat || undefined,
    canonical: SITE_URL + pageUrl.path,
    openGraph: {
      title: "".concat(article.title, " | ").concat(SITE_NAME),
      description: article.hat || undefined,
      url: SITE_URL + pageUrl.path,
      images: [{
        alt: (_article$seo$alt = article.seo.alt) !== null && _article$seo$alt !== void 0 ? _article$seo$alt : undefined,
        height: (_article$seo$height = article.seo.height) !== null && _article$seo$height !== void 0 ? _article$seo$height : undefined,
        url: article.seo.src,
        width: (_article$seo$width = article.seo.width) !== null && _article$seo$width !== void 0 ? _article$seo$width : undefined
      }],
      type: 'article',
      article: {
        publishedTime: (_article$firstPublish = article.firstPublishedAt) !== null && _article$firstPublish !== void 0 ? _article$firstPublish : undefined,
        tags: [article.section].concat(_toConsumableArray(article.tags.map(function (tag) {
          return tag.name;
        })))
      }
    },
    robotsProps: {
      maxImagePreview: 'large'
    }
  }), __jsx(Container, null, __jsx(BreadCrumbs, {
    crumbs: pageUrl.crumbs
  }), __jsx(Section, null, __jsx(Head, {
    article: article,
    readTime: readTime
  }), __jsx(Content, {
    article: article,
    setReadTime: setReadTime,
    url: SITE_URL + pageUrl.path
  }), __jsx(Author, {
    article: article
  }), __jsx(Block, null, __jsx(S.heading.TitleCardArticle, {
    as: "h3"
  }, "Tags associ\xE9s \xE0 l\u2019article"), __jsx(TagList, {
    context: "article",
    tagList: article.tags
  }))), __jsx(Similar, {
    article: article
  })));
}
var Section = styled.section.withConfig({
  displayName: "article__Section",
  componentId: "sc-rjywmm-0"
})(["margin:0 auto;max-width:1060px;@media screen and (", "){margin-top:32px;position:relative;}"], breakpoint.TABLET);
var Block = styled.section.withConfig({
  displayName: "article__Block",
  componentId: "sc-rjywmm-1"
})(["", "{display:flex;align-items:center;justify-content:center;margin-bottom:10px;}"], S.heading.TitleCardArticle);